import { initializeApp } from "firebase/app";
import { getAuth } from "firebase/auth";
import { getFirestore } from "firebase/firestore";

const firebaseConfig = {
  apiKey: "AIzaSyClEvooVcwwFmkK49-U4BJ_mLDSzta9vYY",
  authDomain: "haulmate-63162.firebaseapp.com",
  projectId: "haulmate-63162",
  storageBucket: "haulmate-63162.firebasestorage.app",
  messagingSenderId: "815393381581",
  appId: "1:815393381581:web:3a7e123950e7dc6de29d84",
  measurementId: "G-LCBZNV8PTM"
};

const app = initializeApp(firebaseConfig);
export const auth = getAuth(app);
export const db = getFirestore(app);